import styled from 'styled-components';
import React, { useState, useEffect, useRef } from "react";
import Slide from "../slide.js";

function KUOS(){
    return (
        <Wrapper>
            <Slide img={10} inputText="test"/>
        </Wrapper>
    )
}  
const Wrapper = styled.div`
position : relative; 
top : 70px;

`

export default KUOS;